import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Formik, Form, Field } from "formik";
import { List } from "semantic-ui-react";
import * as Yup from 'yup';
import MyTextInput from "../../app/common/form/MyTextInput";
import MyDateInput from "../../app/common/form/MyDateInput";
import { Accordion, AccordionSection, Input } from 'react-rainbow-components';
import { createCATCursosFormValues} from "../../app/models/CATCursos";
import { CATEdiciones, CATEdiciones2, CATEdicionesFormValues } from "../../app/models/CATEdiciones";
import { Header, Segment } from "semantic-ui-react";
import { useStore } from '../../app/stores/store';
import { createCATModulos, createCATModulosFormValues } from '../../app/models/CATModulos';
import { Message } from 'semantic-ui-react'
import { getCATCursoDetail, getCATCursoDetailFormValues } from "../../app/models/DetailCATCurso";
import CrearEdicion from "./crearEdicion" 
import { MySelectInput } from "../../app/common/form/MySelectInput";
import { MySelectInputEdiciones } from "../../app/common/form/MySelectInput";
import { AiOutlineConsoleSql } from "react-icons/ai";
import { Delegacion } from '../../app/models/ListDelegaciones';
import ListaDelegacionesStore from "../../app/stores/DelegacionesStore";
import MyTextInputBasic from "../../app/common/form/MyTextInput";

const StyledHeader = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Header_a = () => (
    <StyledHeader>
        Crear Nueva Edición
    </StyledHeader>
);

interface Props {
  idCurso: any
}

export const opcionesSiNo = [
  {text: 'Si', value: 'Si'},
  {text: 'No', value: 'No'},
]

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
    resetContainer: {
      padding: theme.spacing(3),
    },
  }),
);

function getSteps() {
  return ['Información general', 'Ediciones'];
}

let cuentasPersona:any = []
let Docenteslista:any = []
let delegaciones: any = [];

export default observer(function EditCursos({idCurso} : Props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [open, setOpen] = React.useState(true);
  const [selectedImage, setSelectedImage] = useState<any>([]);
  const [info, stInfo] = useState<getCATCursoDetailFormValues>(new getCATCursoDetailFormValues());
  const [selectedBanner, setSelectedBanner] = useState<any>([]);
  const steps = getSteps();
  
  const {CATCursosStore,CATModulosStore, modalStore, CCTiposDeCuentasStore, ListaDocentesStore, ListaDelegacionesStore} = useStore();
  const {loadCCTiposDeCuentas} = CCTiposDeCuentasStore
  const {loadCATCursosById, updateCATCourses, updateCATEdiciones, createCATEdiciones} = CATCursosStore
  const {createCATModulosFun} = CATModulosStore
  const {loadListaDocentess} = ListaDocentesStore;
  const {loadListaDelegaciones, ListaDelegacionesEntry} = ListaDelegacionesStore;

  const changeHandler1 =  (event: React.ChangeEvent<any>)  =>{
    setSelectedImage(event.currentTarget.files[0]);  
  } 
  
  useEffect(() => {
    loadListaDocentess().then(() => {
      if(Docenteslista.length > 0){
        Docenteslista = []
      }
      ListaDocentesStore.ListaDocentesByCodigo.map((item) => {
        item.records.map((item2) => {
          const c = {text: item2.fullName, value: item2.guid}
          Docenteslista.push(c)
        })
      })      
    })
    loadCATCursosById(idCurso).then(info => {
      stInfo(new getCATCursoDetailFormValues(info))
      
    })
    loadCCTiposDeCuentas().then(() => {
      if(cuentasPersona.length > 0){
        cuentasPersona = []
      }
      CCTiposDeCuentasStore.CCTipoDeCuentaByCodigo.map((item) => {
        const c = {text: item.descripcion.toString(), value: item.codigoTipoCuenta.toString()}
        cuentasPersona.push(c)
      })
    })

    loadListaDelegaciones().then((item) => {
      item.map((dele) => {
        const c = {text: dele.delegacion, value: dele.id}
        delegaciones.push(c)
      })})
    
  }, [delegaciones]);

  function setDelegacion()
  {
    return 2;
  }

  const changeHandler2 =  (event: React.ChangeEvent<any>)  =>{
    setSelectedBanner(event.currentTarget.files[0]);  
  } 

  const handleReset = () => {
    setActiveStep(0);
  };

  function getStepContent(step: number) {

    function handleNext1(valor: any){
      setActiveStep(1);
      const valorCrear:createCATCursosFormValues = valor
      updateCATCourses(idCurso, valorCrear, selectedImage, selectedBanner)
      console.log(valorCrear, valor)
    };

    function handleNext2(valor: any){     
      updateCATEdiciones(valor, valor.id)
    };

    const handleClick = () => {
      setOpen(!open);
    };

    function handleNext1Otro(valor: any){
      setActiveStep(1);
    };

    function handleNext2Otro(valor: any){
      setActiveStep(2);
    };

    function handleNext3(valor: any){
      const valorCrear:CATEdiciones2 = valor
      let newEdicion:CATEdicionesFormValues = {
        numeroEdicion: valorCrear.numeroEdicion,
        id: 0,
        codigoCuenta: valorCrear.codigoCuenta,
        fechaDeInicioInscripcion: valorCrear.fechaDeInicioInscripcion,
        fechaDeFinalizacionInscripcion: valorCrear.fechaDeFinalizacionInscripcion,
        fechaDeInicioDuracion: valorCrear.fechaDeInicioDuracion,
        fechaDeFinalizacionDuracion: valorCrear.fechaDeFinalizacionDuracion,
        fechaInicioEntrevista: valorCrear.fechaInicioEntrevista,
        fechaFinalEntrevista: valorCrear.fechaFinalEntrevista,
        fechaInicioPropedeutico: valorCrear.fechaInicioPropedeutico,
        fechaFinalPropedeutico: valorCrear.fechaFinalPropedeutico,
        limiteCupo: valorCrear.limiteCupo,
        cupoActual: valorCrear.cupoActual,
        edicionEspecial: valor.edicionEspecial.toLowerCase() == "true",
        preInscripcion: valor.preInscripcion.toLowerCase() == "true",
        aprobadoPor: valorCrear.aprobadoPor,
        catCursosId: idCurso,
        year: valorCrear.year,
        is_active: valor.is_active,
        catedratico: valorCrear.catedratico,
        fechasMaestria: undefined,
        nivel: valorCrear.nivel,
        certificacion: valorCrear.certificacion       
       
      }
      
      createCATEdiciones(newEdicion)
    };

    function handleNext3Otro(valor: any){
      setActiveStep(3);
    };

    const validationSchema = Yup.object({
      nombre: Yup.string().required('Obligatorio'),
      codigoCurso: Yup.string().required('Obligatorio'),
      modalidad: Yup.string().required('Obligatorio'),
      contacto: Yup.string().required('Obligatorio'),
      objetivo: Yup.string().required('Obligatorio')
    })
    
    const validationSchema2 = Yup.object({
      numeroEdicion: Yup.string().required('Obligatorio'),
      fechaDeInicioInscripcion: Yup.string().required('Obligatorio'),
      fechaDeFinalizacionInscripcion: Yup.string().required('Obligatorio'),
      fechaDeInicioDuracion: Yup.string().required('Obligatorio'),
      fechaDeFinalizacionDuracion: Yup.string().required('Obligatorio'),
      limiteCupo: Yup.string().required('Obligatorio'),
      aprobadoPor: Yup.string().required('Obligatorio'),
      year: Yup.string().required('Obligatorio'),
    })

    const validationSchema3 = Yup.object({
      modulo: Yup.string().required('Obligatorio'),
      tema: Yup.string().required('Obligatorio'),
    })
    
    switch (step) {
      case 0:        
        return (
            <div>
              <div className="pagina_formulario">
                  <Segment className="contenedor_formulario">
                      <Formik 
                              enableReinitialize 
                              initialValues={info} 
                              onSubmit={values => {
                                handleNext1(values)             
                              }}>
                          {({handleSubmit, isValid, isSubmitting, dirty}) => (                            
                              <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                  <div>
                                      <Header size="small" content="Nombre del curso" />
                                      <MyTextInputBasic id="" name='nombre' placeholder='' />
                                  </div>
                                  <div>
                                      <Header size="small" content="¿En qué consiste?" />
                                      <MyTextInputBasic name='objetivos' placeholder='' />
                                  </div>
                                  <div>
                                      <Header size="small" content="¿A quién va dirigido?" />
                                      <MyTextInputBasic name='perfil' placeholder='' />
                                  </div>
                                  <div>
                                      <Header size="small" content="Competencias" />
                                      <MyTextInputBasic name='competencias' placeholder='' />
                                  </div>
                                  <div>
                                      <Header size="small" content="Contenido:" />
                                      <MyTextInputBasic name='contenido' placeholder='' />
                                  </div>
                                  <div>
                                      <Header size="small" content="Criterios de evaluación:" />
                                      <MyTextInputBasic name='metodología' placeholder='' />
                                  </div>
                                  <div>
                                      <Header size="small" content="Modalidad del curso" />
                                      <MyTextInputBasic id=" " name='modalidad' placeholder='' />
                                  </div>
                                  <div>
                                      <Header size="small" content="Correo de contacto" />
                                      <MyTextInputBasic name='contacto' type="email" placeholder='' />
                                  </div>
                                  <div>
                                                                        <Header size="small" content="Teléfono de contacto" />
                                                                        <MyTextInput name='phone' type="text" placeholder='' />
                                                                    </div>
                                  <div>
                                      <Header size="small" content="Imagen del curso" />
                                      <input name='imagen' id="imagen" type="file" placeholder='' onChange={changeHandler1} style={{backgroundColor: "rgb(233, 233, 231)", border: "none"}} accept="image/png, .jpeg, .jpg, image/gif" />
                                  </div>
                                  <div>
                                      <Header size="small" content="Banner del curso" />
                                      <input name='banner' id="banner" type="file" placeholder='' onChange={changeHandler2} style={{backgroundColor: "rgb(233, 233, 231)", border: "none"}} accept="image/png, .jpeg, .jpg, image/gif" />
                                  </div>
                                  <div>
                                      <Header size="small" content="PDF del curso" />
                                      <MyTextInputBasic name='iFrame' type="text" placeholder='' />
                                  </div>
                                  <div>
                                    <Header size="small" content="Nivel" />
                                    <MyTextInputBasic name="nivel" type="text" placeholder="" />
                                  </div>
                                  <div>
                                    <Header size="small" content="Delegación" />
                                    <MySelectInputEdiciones name='certificacion' id="" options={delegaciones} placeholder=''  />
                                  </div>
                                  <br></br>
                                  <div>
                                      <Button
                                      variant="contained"
                                      color="primary"
                                      type="submit"
                                      className={classes.button}
                                      >Guardar</Button>
                                      <Button
                                      variant="contained"
                                      onClick={handleNext1Otro}
                                      className={classes.button}
                                      >Siguiente</Button>
                                  </div>
                              </Form>
                          )}
                      </Formik>
                  </Segment>
          </div>
            </div>
        );
      case 1:
        return (
          <div>
            {CATCursosStore.getCATCursoByCodigo.map((item) => {
              return(
                <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    key={item.id}
                  >
                {item.edicion?.map((item2) => {
                  let fecha_Inicial = new Date(item2.fechaDeInicioDuracion)
                  let fecha_Final = new Date(item2.fechaDeFinalizacionDuracion)
                  
                  return(
                      
                        <div className="rainbow-m-around_xx-large" key={item2.id}>
                          <Accordion id="accordion-1">
                              <AccordionSection label={item2.numeroEdicion + " (" + fecha_Inicial.toLocaleDateString() + " - " + fecha_Final.toLocaleDateString() + ")"}>
                              <div className="pagina_formulario">
                                    <Segment className="contenedor_formulario">
                                        <Formik 
                                                enableReinitialize 
                                                initialValues={item2} 
                                                onSubmit={values => handleNext2(values)}>
                                            {({handleSubmit, isValid, isSubmitting, dirty}) => (
                                                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                                    <div>
                                                        <Header size="small" content="Fecha de inicio de inscripción" />
                                                        <MyDateInput placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy' name='fechaDeInicioInscripcion' />
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="Fecha de finalización de inscripción" />
                                                        <MyDateInput name='fechaDeFinalizacionInscripcion' placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy'/>
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="Fecha de inicio del curso" />
                                                        <MyDateInput name='fechaDeInicioDuracion' placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy' />
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="Fecha de finalización del curso" />
                                                        <MyDateInput name='fechaDeFinalizacionDuracion' placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy' />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Fecha de inicio de entrevista" />
                                                      <MyDateInput name="fechaInicioEntrevista" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" value={item2.fechasMaestria?.filter(x => x.tipo == 'Entrevista')[0]?.fechaInicio}  />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Fecha de finalización de entrevista" />
                                                      <MyDateInput name="fechaFinalEntrevista" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" value={item2.fechasMaestria?.filter(x => x.tipo == 'Entrevista')[0]?.fechaFinal}  />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Fecha de inicio de propedeutico" />
                                                      <MyDateInput name="fechaInicioPropedeutico" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" value={item2.fechasMaestria?.filter(x => x.tipo == 'Propedeutico')[0]?.fechaInicio}  />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Fecha de finalización de propedeutico" />
                                                      <MyDateInput name="fechaFinalPropedeutico" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" value={item2.fechasMaestria?.filter(x => x.tipo == 'Propedeutico')[0]?.fechaFinal}  />
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="Limite de cupo" />
                                                        <MyTextInputBasic id="limiteCupo" name='limiteCupo' placeholder='' type="number" />
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="¿Es una edición especial?" />
                                                        <Field as="select" name="edicionEspecial" id="edicionEspecial">
                                                          <option value="false">No</option>
                                                          <option value="true">Si</option>
                                                        </Field>
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="¿Requiere de una preinscripción?" />
                                                        <Field as="select" name="preInscripcion" id="preInscripcion">
                                                          <option value="false">No</option>
                                                          <option value="true">Si</option>
                                                        </Field>
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="Aprobado por" />
                                                        <MyTextInputBasic id="aprobadoPor" name='aprobadoPor' placeholder='' />
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="Año del curso" />
                                                        <MyTextInputBasic name='year' id="" placeholder="" />
                                                    </div>
                                                    <div>
                                                        <Header size="small" content="Catedratico" />
                                                        <MySelectInput name='catedratico' id="" options={Docenteslista} placeholder='' />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Hacer visible el curso en la plataforma" />
                                                      <Field type="checkbox" name="is_active" id="botonActivo"/>
                                                    </div>
                                                    <br></br>
                                                    <div>
                                                    <Button
                                                        variant="contained"
                                                        type="submit"
                                                        color="primary"
                                                        className={classes.button}
                                                        >Guardar</Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Segment>
                            </div>
                              </AccordionSection>
                          </Accordion>
                        </div>
                      
                  )
                })}
               </List>
              )
            })}

          <Accordion id="accordion-1">
            <AccordionSection 
            label={<Header_a />}                       
            >
            <div className="pagina_formulario">
            <Segment className="contenedor_formulario">
                <Formik 
                      enableReinitialize
                      onReset={() => {
                        (document.getElementById("numeroEdicion") as HTMLInputElement).value = "";
                        // (document.getElementById("codigoCuenta") as HTMLInputElement).value ="";
                        (document.getElementById("limiteCupo") as HTMLInputElement).value = "";
                        (document.getElementById("edicionEspecial") as HTMLInputElement).value = "";
                        (document.getElementById("preInscripcion") as HTMLInputElement).value = "";
                        (document.getElementById("aprobadoPor") as HTMLInputElement).value = "";
                        (document.getElementById("botonActivo") as HTMLInputElement).checked = false;                        
                      } }
                      onSubmit={values => handleNext3(values)}
                      initialValues={CATEdiciones}>
                    {({handleSubmit, isValid, isSubmitting, dirty}) => (
                        <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                            <div>
                                <Header size="small" content="Número de edición" />
                                <MyTextInputBasic id="numeroEdicion" name='numeroEdicion' placeholder='' type="number" />
                            </div>
                            <div>
                                <Header size="small" content="Código de cuenta" />
                                <MySelectInput name='codigoCuenta' id="" options={cuentasPersona} placeholder='' />
                            </div>
                            <div>
                                <Header size="small" content="Fecha de inicio de inscripción" />
                                <MyDateInput placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy' name='fechaDeInicioInscripcion' />
                            </div>
                            <div>
                                <Header size="small" content="Fecha de finalización de inscripción" />
                                <MyDateInput name='fechaDeFinalizacionInscripcion' placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy'/>
                            </div>
                            <div>
                                <Header size="small" content="Fecha de inicio del curso" />
                                <MyDateInput name='fechaDeInicioDuracion' placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy' />
                            </div>
                            <div>
                                <Header size="small" content="Fecha de finalización del curso" />
                                <MyDateInput name='fechaDeFinalizacionDuracion' placeholderText='dd/mm/aaaa' dateFormat='dd/MM/yyyy' />
                            </div>
                            <div>
                                                      <Header size="small" content="Fecha de inicio de entrevista" />
                                                      <MyDateInput name="fechaInicioEntrevista" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Fecha de finalización de entrevista" />
                                                      <MyDateInput name="fechaFinalEntrevista" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Fecha de inicio de propedeutico" />
                                                      <MyDateInput name="fechaInicioPropedeutico" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" />
                                                    </div>
                                                    <div>
                                                      <Header size="small" content="Fecha de finalización de propedeutico" />
                                                      <MyDateInput name="fechaFinalPropedeutico" placeholderText="dd/mm/aaaa" dateFormat="dd/MM/yyyy" />
                                                    </div>
                            <div>
                                <Header size="small" content="Limite de cupo" />
                                <MyTextInputBasic id="limiteCupo" name='limiteCupo' placeholder='' type="number" />
                            </div>
                            <div>
                                <Header size="small" content="¿Es una edición especial?" />
                                <Field as="select" name="edicionEspecial" id="edicionEspecial">
                                  <option value=""></option>
                                  <option value="false">No</option>
                                  <option value="true">Si</option>
                                </Field>
                            </div>
                            <div>
                                <Header size="small" content="¿Requiere de una preinscripción?" />
                                <Field as="select" name="preInscripcion" id="preInscripcion">
                                  <option value=""></option>
                                  <option value="false">No</option>
                                  <option value="true">Si</option>
                                </Field>
                            </div>
                            <div>
                                <Header size="small" content="Aprobado por" />
                                <MyTextInputBasic id="aprobadoPor" name='aprobadoPor' placeholder='' />
                            </div>
                            <div>
                                <Header size="small" content="Año del curso" />
                                <MyTextInputBasic name='year' id="" placeholder="" />
                            </div>
                            <div>
                                                        <Header size="small" content="Catedratico" />
                                                        <MySelectInput name='catedratico' id="" options={Docenteslista} placeholder='' />
                                                    </div>
                            <div>
                              <Header size="small" content="Hacer visible el curso en la plataforma" />
                              <Field type="checkbox" name="is_active" id="botonActivo"/>
                            </div>
                            <br></br>
                            <div>
                                <Button
                                variant="contained"
                                type="submit"
                                className={classes.button}
                                style={{marginRight: "10px"}}>Crear</Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Segment>
            </div>
            </AccordionSection>
          </Accordion>
          <Button
            variant="contained"
            onClick={handleNext2Otro}
            className={classes.button}
            >Siguiente</Button>
        </div>
        );
      default:
        return 'No existe';
    }
  }
  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <div>{getStepContent(index)}</div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Message color='green'>
            <Message.Header>¡Todos los pasos han sido completados correctamente!</Message.Header>
          </Message>
          <Button onClick={modalStore.closeModal} variant="contained" className={classes.button}>
            Cerrar
          </Button>
        </Paper>
      )}
    </div>
  );
})